import styled from 'styled-components';

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const ScoreSection = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  flex-wrap: wrap;
`;

export const StatCard = styled.div`
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 20px;
  min-width: 160px;
  text-align: center;
`;

export const ChecklistWrapper = styled.div`
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 24px;
`;
